import React from 'react'
import styled from '@emotion/styled/macro'

const StyledTooltipText = styled.span`
  visibility: hidden;
  width: max-content;
  height: 22px;
  background-color: #3e3f42;
  color: #fff;
  text-align: center;
  padding: 6px 15px;
  border-radius: 6px;
  bottom: 130%;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
  z-index: 1;

  &:after {
    content: ' ';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #3e3f42 transparent transparent transparent;
  }
`

const StyledTooltip = styled.div`
  position: relative;
  display: inline-block;
  margin: 2%;

  &:hover {
    ${StyledTooltipText} {
      visibility: visible;
    }
  }
`

type Props = {
  children: any
  title: Required<string>
  idName?: string
}

const ToolTip = ({ children, title, idName }: Props) => (
  <StyledTooltip id={idName}>
    {children}
    <StyledTooltipText>{title}</StyledTooltipText>
  </StyledTooltip>
)

export default ToolTip
